import { render } from "./CalculatorRestriction.vue?vue&type=template&id=006a078b&ts=true"
import script from "./CalculatorRestriction.vue?vue&type=script&lang=ts"
export * from "./CalculatorRestriction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__